import { render, staticRenderFns } from "./hinge-joint.vue?vue&type=template&id=74abab50&scoped=true&"
import script from "./hinge-joint.js?vue&type=script&lang=js&"
export * from "./hinge-joint.js?vue&type=script&lang=js&"
import style0 from "./hinge-joint.vue?vue&type=style&index=0&id=74abab50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74abab50",
  null
  
)

export default component.exports